import { useState, useEffect } from "react";
import { Center, Container, Space, Text } from "@mantine/core";
import { NewPasswordWidget } from "../../widgets/new-password/NewPassword";
import { Logo } from "../../shared/svg";
import { useLocation } from "react-router";
import { passwordRecoveryToken } from "../../api/userApi";

export const NewPasswordPage = () => {
  const [isTokenValid, setIsTokenValid] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const token = params.get("token");

  useEffect(() => {
    if (!token) {
      setError("Token is missing");
      setIsLoading(false);
      return;
    }

    const validateToken = async () => {
      try {
        await passwordRecoveryToken(token);
        setIsTokenValid(true);
      } catch (error) {
        setIsTokenValid(false);
        setError("Invalid token");
      } finally {
        setIsLoading(false);
      }
    };

    validateToken();
  }, [token]);

  if (isLoading) {
    return (
      <Center mt={50} mb={50}>
        <Container size="sm" w={656}>
          <center>
            <Logo />
            <Space h="24px" />
            <Text>Loading...</Text>
          </center>
        </Container>
      </Center>
    );
  }

  return (
    <Center mt={50} mb={50}>
      <Container size="sm" w={656}>
        <center>
          <Logo />
          <Space h="24px" />
          {isTokenValid ? (
            <NewPasswordWidget token={token!} />
          ) : (
            <Text color="red">{error}</Text>
          )}
        </center>
      </Container>
    </Center>
  );
};
